import * as React from 'react';
import Config from '../Config';
import PortalIntegration from '../PortalIntegration';

interface DeveloperOptionsState {
    changed?: boolean;
}

export default class DeveloperOptions extends React.Component<undefined, DeveloperOptionsState> {

    private _webPortalBaseUrlInput;
    private _coreBaseUrlInput;
    private _marketingBaseUrlInput;
    private _overrideUsernameInput;

    constructor(props: undefined) {
        super(props);

        this.state = {
            changed: false
        };

    }

    componentDidMount() {
        jQuery(this._webPortalBaseUrlInput).val(Config.getWebPortalBaseUrl());
        jQuery(this._coreBaseUrlInput).val(Config.getCoreBaseUrl());
        jQuery(this._marketingBaseUrlInput).val(Config.getMarketingBaseUrl());
        jQuery(this._overrideUsernameInput).val(Config.getOverrideUsername());
    }

    render() {
        return <div className="DeveloperOptions">
            {this.state.changed ? <p>Refresh page to use new values.</p> : null}
            <p>
                <label>User Agent:</label>
                <div>{PortalIntegration.getUserAgentString()}</div>
            </p>
            <p>
                <label>Web Portal Base URL:</label>
                <input type="text" ref={(ele) => { this._webPortalBaseUrlInput = ele; }} />
            </p>
            <p>
                <label>Core Base URL:</label>
                <input type="text" ref={(ele) => { this._coreBaseUrlInput = ele; }} />
            </p>
            <p>
                <label>Marketing Base URL:</label>
                <input type="text" ref={(ele) => { this._marketingBaseUrlInput = ele; }} />
            </p>
            <p>
                <label>Override Username:</label>
                <input type="text" ref={(ele) => { this._overrideUsernameInput = ele; }} />
            </p>
            <p>
                <button onClick={(e) => this._saveClicked(e)}>Save</button>
            </p>
            <p>
                <button onClick={(e) => this._clearClicked(e)}>Clear all</button>
            </p>
        </div>;
    }

    private _saveClicked(e) {
        Config.setWebPortalBaseUrl(jQuery(this._webPortalBaseUrlInput).val());
        Config.setCoreBaseUrl(jQuery(this._coreBaseUrlInput).val());
        Config.setMarketingBaseUrl(jQuery(this._marketingBaseUrlInput).val());
        Config.setOverrideUsername(jQuery(this._overrideUsernameInput).val());
        
        this.setState({
            changed: true
        });
    }

    private _clearClicked(e) {
        Config.clearAll();
        this.setState({
            changed: true
        });
    }

}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/components/DeveloperOptions.tsx